import validate from "/app/node_modules/.pnpm/nuxt@4.5.2_8d0ef075f0b6089edd36efcec896d152/node_modules/nuxt/dist/pages/runtime/validate.js";
import be_45nl_45prefix_45redirect_45global from "/app/apps/main-site/modern/src/app/middleware/beNlPrefixRedirect.global.ts";
import focus_45page_45layout_45global from "/app/apps/main-site/modern/src/app/middleware/focusPageLayout.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.5.2_8d0ef075f0b6089edd36efcec896d152/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  be_45nl_45prefix_45redirect_45global,
  focus_45page_45layout_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}